module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/studio-suns_access_01-78d0edab92e181d6dc5228fa867d357d.jpg";